/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.inbox.getUnreadCount'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  section: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['reports', 'subjects', 'accountStatus']
    }>(),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  unreadCounts: /*#__PURE__*/ l.ref<UnreadCounts>((() => unreadCounts) as any),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type UnreadCounts = {
  $type?: 'tools.ozone.inbox.getUnreadCount#unreadCounts'
  total: number
  reports?: number
  subjects?: number
  accountStatus?: number
}

export type { UnreadCounts }

const unreadCounts = /*#__PURE__*/ l.typedObject<UnreadCounts>(
  $nsid,
  'unreadCounts',
  /*#__PURE__*/ l.object({
    total: /*#__PURE__*/ l.integer({ minimum: 0 }),
    reports: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({ minimum: 0 })),
    subjects: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({ minimum: 0 })),
    accountStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ maximum: 1, minimum: 0 }),
    ),
  }),
)

export { unreadCounts }
